/* eslint-disable no-unused-expressions */
import {Fragment} from 'react';

import {DocumentOnList} from '../documents';
import './AnswerDetail.css';
import {draftjsToHTML} from '../WysiwygEditor/WysiwygHelpers';


export const AnswerDetail = (props) => {

	const renderQuestions = (block) => {
		let questionRows;
		let result;
		let sortedQuestions = block.questionsInBlock.sort((a, b) => a.orderNumber - b.orderNumber);
		questionRows = sortedQuestions.map((question,index) => {
			let answerReference = props.answers.find(el => el.questionInBlock.referenceId === question.id)
			return questionRows = <Fragment key={question.id}>
				<tr className='quest-row' key={question.id}>
					<td>{index + 1}</td>
					<td id={'cell' + question.orderNumber}>{question.questionContent}</td>
					<td id='answerTableCell' className='answerTableCell'>
						{answerReference && answerReference.answer !== '' ?
							(<p>{answerReference.answer}</p>) :null}
					</td>
				</tr>
				{answerReference && answerReference.textAnswer !== null ?
					(<tr className='quest-second-row'>
						<td colSpan='3'>
							<p className='my-3'><span
								className='font-weight-bold'>UWAGA: </span><div dangerouslySetInnerHTML={{ __html: draftjsToHTML(answerReference.textAnswer) }} />{answerReference.relevantInPostControlNote ?
								<span className='font-weight-bold'> (do dokumentu pokontrolnego)</span> : null}</p>
						</td>
					</tr>) : null}
				{answerReference && answerReference.attachments.length > 0 &&
					<tr className='quest-second-row'>
						<td colSpan='3'>
							<div className='my-3'>
								<span className='font-weight-bold'>ZAŁĄCZNIKI:</span>
								{answerReference.attachments.map((attachment, index) => (
									<DocumentOnList
										document={attachment.document}
										key={attachment.id}
										index={index + 1}
										withIndexOnList
									/>
								))}
							</div>
						</td>
					</tr>
				}
			</Fragment>
		});

		result = <table id='answerTable'>
			<tbody>
			<tr id='titleRow'>
				<td className='width-100'>LP.</td>
				<td>PYTANIE</td>
				<td className='width-120'>ODPOWIEDŹ</td>
			</tr>
			{questionRows}
			</tbody>
		</table>;

		return result;
	};

	const renderAnswerTable = (blocks) => {
		let table = (<Fragment>
			{
				blocks.map(function (block, index) {

					return <div id={'block-' + block.id} key={block.id.toString()}>

						<h4 className='block_title' style={{cursor: 'default'}}> {(index + 1) + '. ' + block.name} </h4>
						{renderQuestions(block)}
						<div className='mb-4'>&nbsp;</div>
					</div>
				})
			}
		</Fragment>);

		return table;
	};

	let blocks = {};
	if (props.questionList) {
		blocks = props.questionList.blocksInList;
	}

	if (blocks && blocks.length > 0) {
		return (
			<div>
				{renderAnswerTable(blocks)}
			</div>
		);
	} else {
		return (<p>Nie ma bloków</p>);
	}
};
